export default "__VITE_ASSET__B7Xh7mA___"